export const support_request_types = [
  { value: 'voli__cambiare_o_annullare_il_volo', text: 'Cambiare o annullare il volo' },
  { value: 'voli__bagagli__posti_e_altri_servizi', text: 'Bagagli, posti e altri servizi' },
  { value: 'voli__pagare_col_welfare_o_con_card', text: 'Pagare col welfare o con card' },
  { value: 'voli_il_volo_è_cambiato_o_cancellato', text: 'Il volo è cambiato o cancellato' },
  { value: 'voli_check-in_e_carta_d_imbarco', text: 'Check-in e carta d\'imbarco' },
  { value: 'voli__assistenza_per_disabilità_o_mobilità', text: 'Assistenza per disabilità o mobilità' },
  { value: 'voli_problemi_con_il_sito', text: 'Problemi con il sito' },
  { value: 'voli_altro', text: 'Altro' },
]
